
import request from '@/api/request'

// 获取基础活动
export function getprepaidActivity() {
  return request({
      url: `/activity/prepaid-activity`,
      method: 'get',
  });
}

// 获取九宫格抽奖列表
export function getList(activityId) {
    return request({
        url: `/activity/prepaid-activity/getPositionById/${activityId}`,
        method: 'get',
    });
}

// 抽奖
export function getVote(positionId) {
  return request({
      url: `/activity/prepaid-activity/vote/${positionId}`,
      method: 'post',
  });
}

// 获取预存动态
export function getPrepaidPost() {
  return request({
      url: `/member/member-prepaid-apply-bill/post`,
      method: 'get',
  });
}

// 获取预存增值
export function getPREPAID_CONFIG() {
  return request({
      url: `/system/sys-setting/PREPAID_CONFIG`,
      method: 'get',
  });
}

// 保存收获地址
export function setAddAddress(data) {
  return request({
      url: `/activity/prepaid-activity/addAddress`,
      method: 'post',
      data
  });
}

// 获取中将记录
export function getRecordsLog(params) {
  return request({
      url: `/activity/prepaid-activity/my/records`,
      method: 'get',
      params
  });
}

// 获取兑换记录
export function getChangeLog(params) {
  return request({
      url: `/activity/prepaid-activity/my/change`,
      method: 'get',
      params
  });
}





